/**
 * @file 我的账户，包含我的投资，解质押，领取收益功能
 */
import { useShowClaimModal } from './hooks';
import { InvestInfo } from './investInfo';
import { ClaimModal } from './claimModal';
import { OperationTab } from '@/types/common';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { RedeemChooseModal } from './redeemChooseModal';
import { useState } from 'react';
import { AirdropActivity } from '@/types/bbsol';

interface Props {
  onChangeTab: (v: OperationTab) => void;
  activity: AirdropActivity;
}

export const Account = (props: Props) => {
  const { onChangeTab, activity } = props;
  const [showModal, setShowModal] = useState(false);
  const { poolInfo } = usePoolInfoContext();
  const { claimType, showClaimModal, onOpenClaimModal, onCloseClaimModal } =
    useShowClaimModal();

  return (
    <>
      {/* 我的投资信息 */}
      <InvestInfo
        setShowModal={setShowModal}
        onOpenClaimModal={onOpenClaimModal}
        onChangeTab={onChangeTab}
        activity={activity}
      />
      <RedeemChooseModal showModal={showModal} setShowModal={setShowModal} />
      {/* 领取收益功能，也承担着提取本金角色 */}
      {showClaimModal && (
        <ClaimModal
          poolInfo={poolInfo}
          claimType={claimType}
          onCloseClaimModal={onCloseClaimModal}
        />
      )}
    </>
  );
};
